import { useState, useCallback } from 'react';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

function useSelection(editor, initialSelection = null) {
  const [selection, setSelection] = useState(initialSelection);
  const blur = useCallback(() => {
    try {
      ReactEditor.blur(editor);
    } catch {
      // To-do: Add error logging
    }
  }, [editor]);
  const focus = useCallback(() => {
    try {
      ReactEditor.focus(editor);
    } catch {
      // To-do: Add error logging
    }
  }, [editor]);
  const select = useCallback(range => {
    try {
      if (range) {
        Transforms.select(editor, range);
      }
    } catch {
      // To-do: Add error logging
    }
  }, [editor]);
  const restoreSelection = useCallback(range => {
    try {
      if (!ReactEditor.isFocused(editor)) {
        var _ref;
        select((_ref = range !== null && range !== void 0 ? range : editor.selection) !== null && _ref !== void 0 ? _ref : selection);
        focus();
      }
    } catch {
      // To-do: Add error logging
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [editor, selection]);
  const deselect = useCallback(() => {
    try {
      Transforms.deselect(editor);
    } catch {
      // To-do: Add error logging
    }
  }, [editor]);
  return {
    blur,
    focus,
    selection,
    select,
    setSelection,
    restoreSelection,
    deselect
  };
}

export { useSelection };
